<div
    #bar
    class="anc-fb"
    role="toolbar"
    [class.anc-fb--collapsed]="collapsed()"
    [attr.aria-label]="'Filters' | translate"
>
    <ng-template #dateRange>
        <lib-anc-custom-date-range
            class="anc-fb-date"
            [value]="dateRangeValue"
            [popupAlign]="dateRangePopupAlign"
            [size]="dateRangeSize"
            (dateRangeValueChange)="onDateRangeUpdated($event)"
        ></lib-anc-custom-date-range>
    </ng-template>

    <!-- Without chips there is no drawer, so the date range stays in the bar. -->
    <ng-container *ngIf="showDateRange && !chips.length" [ngTemplateOutlet]="dateRange"></ng-container>

    <!-- Opens the chip drawer when the chips don't fit on one line (collapsed); hidden otherwise. -->
    <button
        *ngIf="chips.length"
        #drawerTrigger
        type="button"
        class="anc-fb-toggle"
        [attr.aria-expanded]="drawerOpen()"
        [attr.aria-controls]="drawerId"
        (click)="openDrawer()"
    >
        <span class="anc-fb-count-icon icon icon-filter" aria-hidden="true"></span>
        <span translate>Filters</span>
        <span
            *ngIf="totalAppliedCount > 0"
            class="anc-fb-toggle-count"
            [attr.aria-label]="'Applied filters' | translate"
        >{{ totalAppliedCount }}</span>
    </button>

    <div
        *ngIf="drawerOpen()"
        class="anc-fb-backdrop"
        aria-hidden="true"
        (click)="closeDrawer()"
    ></div>

    <!-- display: contents while the chips fit, so they lay out in the bar exactly as before. -->
    <div
        class="anc-fb-chips"
        [id]="drawerId"
        [class.anc-fb-chips--open]="drawerOpen()"
        [cdkTrapFocus]="drawerOpen()"
        [cdkTrapFocusAutoCapture]="drawerOpen()"
        [attr.role]="drawerOpen() ? 'dialog' : null"
        [attr.aria-modal]="drawerOpen() ? 'true' : null"
        [attr.aria-label]="drawerOpen() ? ('Filters' | translate) : null"
        (keydown.escape)="closeDrawer()"
    >
        <div class="anc-fb-drawer-header">
            <span class="anc-fb-drawer-title" translate>Filters</span>
            <button
                type="button"
                class="anc-fb-drawer-close"
                [attr.aria-label]="'Close' | translate"
                (click)="closeDrawer()"
            >
                <span class="icon icon-x" aria-hidden="true"></span>
            </button>
        </div>

        <!-- With chips, the date range sits first among them: inline while they fit
             (this wrapper is display: contents), inside the drawer when collapsed. -->
        <ng-container *ngIf="showDateRange && chips.length" [ngTemplateOutlet]="dateRange"></ng-container>

        <app-anc-filter-chip
            *ngFor="let chip of chips; trackBy: trackChipById"
            [chip]="chip"
            [value]="values?.[chip.id] ?? null"
            [options]="optionsByChip?.[chip.id] ?? []"
            [optionsLoading]="!!loadingByChip?.[chip.id]"
            [hasMoreOptions]="!!hasMoreByChip?.[chip.id]"
            (open)="chipOpen.emit(chip.id)"
            (valueChange)="chipChange.emit({ chipId: chip.id, value: $event })"
            (loadMore)="loadMore.emit(chip.id)"
        ></app-anc-filter-chip>
    </div>

    <span
        *ngIf="showCountBadge && totalAppliedCount > 0"
        class="anc-fb-count"
        [attr.aria-label]="'Applied filters' | translate"
    >
        <span
            class="anc-fb-count-icon icon icon-filter"
            aria-hidden="true"
        ></span>
        <span class="anc-fb-count-value">{{ totalAppliedCount }}</span>
    </span>

    <button
        *ngIf="showClearAll && totalAppliedCount > 0"
        type="button"
        class="anc-fb-clear"
        (click)="onClearAllClick()"
    >
        <span translate>Clear all</span>
    </button>
</div>
